import { render, staticRenderFns } from "./ReturnedPackageCustomerData.vue?vue&type=template&id=e95eb372&"
import script from "./ReturnedPackageCustomerData.vue?vue&type=script&lang=js&"
export * from "./ReturnedPackageCustomerData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports